// start:ng42.barrel
export * from './cancel-conf.module';
export * from './cancel-conf';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/routes/cancel-conf/index.ts